/**
 * @author wangna
 * @date 17/07/20
 * 前端直接调用
 */
import request from 'superagent';
import Utils from './utils';
import router from '../config/routes'
import store from '../store/index'
import host from 'Host';
import { Message } from 'element-ui';

const root = host.domain;
const root_bip = host.bip; // 大数据报表
const root_imgsvc = host.imgsvc; // 大数据报表
const root_oc = host.oc;
const root_glue = host.glue;

let urlList = [
    root_bip + '/bip/v1/public/report/list',
    root_bip + '/bip/v1/public/report/create',
    root_bip + '/bip/v1/public/report/download',
    root_bip + '/bip/v1/public/report/delete',
    root_bip + '/bip/private/v1/bi/group/hour/data',
    root_bip + '/bip/private/v1/bi/group/business/detail',
    root_bip + '/bip/private/v1/bi/group/view/detail',
    root_bip + '/bip/private/v1/bi/group/school/ranking'
];

function apiBase(method, url, params, success, failure) {
    //var r = request(method, url).type('application/json').set('Token', localStorage.getItem('token')||'').set('account-type', localStorage.getItem('accountType')||'');
    var r = request(method,url);
    if(params.token){

    } else {
        params.token = store.getters.token || '';
    }

    if (urlList.indexOf(url) >= 0) {
        // console.log(window.location.host.indexOf('anlaiye') >= 0)
        params.account_type = 200;
        params.type = store.getters.type;
    } else {
        params.account_type = store.getters.accountType || '1';
    }
    if (params) {
        //params = Utils.filterNull(params);//空字符串过滤
        if (method === 'POST' || method === 'PUT') {
            if (Utils.toType(params) == 'object') {
                // params = JSON.stringify(params);
            };
            r = r.send(params);
        } else if (method == 'GET' || method === 'DELETE') {
            r = r.query(params)
        }
    }
    r.end(function (err, res) {
        if (err) {
            Message({
                message: 'api error',
                type: 'warning'
            });
            return;
        };
        if (res.body.flag && res.body.flag > 0 && res.body.result) {
            if (success) {
                success(res.body);
            }
        } else if(res.body.flag == -90801 || res.body.flag == -90901){
            store.commit('SET_ISLOGOUT', true);
            //未登录
            Message({
                message: res.body.message,
                type: 'warning'
            });
            store.dispatch('LogOut');
        } else if(res.body.flag == -997){
            //未权限
            Message({
                message: res.body.message,
                type: 'warning'
            });
            setTimeout(
                function () {
                    router.push({path: '/dashboard'});
                },1000)
        } else {
            if (failure) {
                failure(res.body);
            } else {
                //alert('error: ' + JSON.stringify(res.body));
                Message({
                    message: res.body.message,
                    type: 'warning'
                });
            }
        }
    });
};




export default {
    get (url, params, success, failure) {
        return apiBase('GET', root + url, params, success, failure)
    },
    post (url, params, success, failure) {
        return apiBase('POST', root + url, params, success, failure)
    },
    put (url, params, success, failure) {
        return apiBase('PUT', root + url, params, success, failure)
    },
    delete (url, params, success, failure) {
        return apiBase('DELETE', root + url, params, success, failure)
    },
    
    get_bip (url, params, success, failure) {
        return apiBase('GET', root_bip + url, params, success, failure)
    },
    post_bip (url, params, success, failure) {
        return apiBase('POST', root_bip + url, params, success, failure)
    },
    put_bip (url, params, success, failure) {
        return apiBase('PUT', root_bip + url, params, success, failure)
    },
    delete_bip (url, params, success, failure) {
        return apiBase('DELETE', root_bip + url, params, success, failure)
    },
    post_imgsvc (url, params, success, failure) {
        return apiBase('POST', root_imgsvc + url, params, success, failure)
    },
    get_glue (url, params, success, failure) {
        return apiBase('GET', root_glue + url, params, success, failure)
    },
    post_glue (url, params, success, failure) {
        return apiBase('POST', root_glue + url, params, success, failure)
    },
    put_glue (url, params, success, failure) {
        return apiBase('PUT', root_glue + url, params, success, failure)
    },
    delete_glue (url, params, success, failure) {
        return apiBase('DELETE', root_glue + url, params, success, failure)
    },
    open (url, params) {
        let open_url = root_oc + url;
        let paramsStr = '';
        if (params) {
            paramsStr = "?";
            for(let k in params) {
                paramsStr += (k + "=" + params[k] + "&");
            }
            paramsStr = paramsStr.slice(0, -1);
        }
        return window.open(open_url + paramsStr);
    }
}



// WEBPACK FOOTER //
// ./vue/common/api.js